var map = {
	"./cedant/cedant.module": [
		"./src/app/cedant/cedant.module.ts"
	],
	"./contract/contract.module": [
		"./src/app/contract/contract.module.ts",
		"contract-contract-module"
	],
	"./insights/insights.module": [
		"./src/app/insights/insights.module.ts",
		"insights-insights-module"
	],
	"./program/program.module": [
		"./src/app/program/program.module.ts"
	],
	"./session/session.module": [
		"./src/app/session/session.module.ts",
		"session-session-module"
	],
	"./settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"settings-settings-module"
	],
	"./style-guide/style-guide.module": [
		"./src/app/style-guide/style-guide.module.ts",
		"style-guide-style-guide-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;